import { render, staticRenderFns } from "./AccessPermissionsListHeader.vue?vue&type=template&id=18bc0c8d&scoped=true&"
import script from "./AccessPermissionsListHeader.vue?vue&type=script&lang=ts&"
export * from "./AccessPermissionsListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AccessPermissionsListHeader.vue?vue&type=style&index=0&id=18bc0c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc0c8d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bc0c8d')) {
      api.createRecord('18bc0c8d', component.options)
    } else {
      api.reload('18bc0c8d', component.options)
    }
    module.hot.accept("./AccessPermissionsListHeader.vue?vue&type=template&id=18bc0c8d&scoped=true&", function () {
      api.rerender('18bc0c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/access-permissions/components/AccessPermissionsListHeader.vue"
export default component.exports